var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  background: '#2a1e1b',
  gridColumn: _vm.pos[0], gridRow: _vm.pos[1]
})})}
var staticRenderFns = []

export { render, staticRenderFns }